import React from "react";
import PropTypes from "prop-types";

const Buttons = ({ isEmpty, onClear, onApply }) => (
  <div className="buttons">
    <a
      className="btn btn-pink btn-block btn-raised"
      disabled={isEmpty && "disabled"}
      onClick={onApply}
    >
      APPLY
    </a>

    <a
      className="btn btn-grey btn-block btn-raised"
      disabled={isEmpty && "disabled"}
      onClick={onClear}
    >
      CLEAR
    </a>
  </div>
);

Buttons.propTypes = {
  isEmpty: PropTypes.bool,
  onClear: PropTypes.func,
  onApply: PropTypes.func
};

export default Buttons;
